import React, { useEffect, useState } from "react";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/thumbnail/lib/styles/index.css";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import { useDispatch, useSelector } from "react-redux";
import { SetApprovalCallsActions ,SetTheJoiningDateCall ,
  sethtmlformatpdfdownoadActions
} from "../../../Redux/Slice";
import { useNavigate } from "react-router-dom";
import { zoomPlugin } from "@react-pdf-viewer/zoom";
import LoaderGIf  from "../../../Assets/LoadingImage.gif"

const PdfView = (props) => {
  const { show, setshow, pdfUrl, createEmployee, Approvel, SubRoleList } =
    props;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const state = useSelector((state) => state);
  const Swal = require("sweetalert2");
  const defaultLayoutPluginInstance = defaultLayoutPlugin();
  const [currentPage, setCurrentPage] = useState(0);
  const [numPages, setNumPages] = useState(0);
  // const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const [RMADMIN , setRMADMN] = useState(false)

  const onDocumentLoad = (e) => {
    setNumPages(e.doc.numPages);
    setCurrentPage(0);
  };

  const zoomPluginInstance = zoomPlugin();
  const {zoomTo } = zoomPluginInstance;
  useEffect(() => {
      zoomTo(1.3);
  }, [zoomTo]);


 useEffect(()=>{
  if (state.EmployeeProfile.EmployeeProfileList !=""&&
    state.EmployeeProfile.EmployeeProfileList != undefined &&
    state.EmployeeProfile.EmployeeProfileList.is_pending  == false &&
    // !state.EmployeeProfile.EmployeeProfileList.is_pending &&
    state.EmployeeProfile.EmployeeProfileList.job_description !=
      undefined &&
    state.EmployeeProfile.EmployeeProfileList.job_description != null &&
    state.EmployeeProfile.EmployeeProfileList.job_description.letter_id !=
      null &&
    state.EmployeeProfile.EmployeeProfileList.job_description.letter_id !=
      undefined
  ) {
    setRMADMN(false)

  } else {
    setRMADMN(false)

  }
 },[state.EmployeeProfile.EmployeeProfileList])


   useEffect(() => {


    

    if (state.ClientBranchIDs.EmployeeDetailsProfile != ""&&
state.ClientBranchIDs.SUBROLE !== 2 &&
state.EmployeeProfile.EmployeeProfileList !== "" &&
state.SideBarFiles.SideBarFile !== "Onboarding" &&
state.NumberCounts.AllFormPDF  === true && 
(
  state.SideBarFiles.SideBarFile === "Approve Request" ||
  state.SideBarFiles.SideBarFile === "Overview" ||
  state.SideBarFiles.SideBarFile === "Onboard Overview"
) &&
state.ClientBranchIDs.EmployeeDetailsProfile !== "") {

    const payload = {
    id: state.ClientBranchIDs.EmployeeDetailsProfile,
    count: 2,
  };

dispatch(sethtmlformatpdfdownoadActions(payload));
   
    }
  }, [
    state.ClientBranchIDs.EmployeeDetailsProfile,
    state.SideBarFiles.SideBarFile,
    state.ClientBranchIDs.SUBROLE,
    state.NumberCounts.AllFormPDF,
  ]);


  ////------------------Declines-------------------------
  const HandleDecline = () => {
    Swal.fire({
      title: "Do you want to Reject?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#234492",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, Reject it!",
      input: "text",
      inputPlaceholder: "Reason for reject...",
      inputValidator: (value) => {
        if (!value) {
          return "You need to provide a reason for rejecting";
        }
      },
    }).then((result) => {
      if (result.isConfirmed) {
        const reason = result.value; // Retrieve the value entered by the user
        const payload = {
          UserId: state.EmployeeProfile.EmployeeProfileList.user_id.id,
          is_pending: true,
          is_decline: true,
          Decline: 1,
          payroll_approved: SubRoleList == 0 ? false : false,
          reason_for_decline: reason, // Include the reason in the payload
        };

        dispatch(SetApprovalCallsActions(payload));
        // DateOfJoing
         if(state.SideBarFiles.SideBarFile == "Approve Request"){ 
        navigate("/approverequestemp");
         }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire({
          text: " Employee verification as been cancel",
          icon: "error",
        });
        Swal.close();
      }
    });
  };

  const HandleVerify = () => {
    Swal.fire({
      title: "Do you want to  Verify?",
      // text: "You won't be able to revert this",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#234492",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, Verify it!",
    }).then((result) => {
      if (result.isConfirmed) {
        // console.log(state.EmployeeProfile.EmployeeProfileList, "userId");
        if (
          state.EmployeeProfile.EmployeeProfileList != undefined ||
          (state.EmployeeProfile.EmployeeProfileList != null &&
            state.EmployeeProfile.EmployeeProfileList.lenght > 0 &&
            state.EmployeeProfile.EmployeeProfileList.user_id != undefined &&
            state.EmployeeProfile.EmployeeProfileList.user_id.id != undefined)
        ) {
          // console.log(SubRoleList, "SubRoleList");
          const payload = {
            UserId: state.EmployeeProfile.EmployeeProfileList.user_id.id,
            //is_pending: true,
            is_pending: SubRoleList == 0 ? true : false,
            is_decline: false, ///is_decline :have to be true when the Rm is need to approve
            create_employee: true,
            Decline: 0,
            payroll_approved:
              SubRoleList == 0 || SubRoleList == 3 ? true : true,
          };
          dispatch(SetApprovalCallsActions(payload));
          if (SubRoleList == 1 || SubRoleList == 3) {
            navigate("/verifystatus");
          } else {
            navigate("/employeeVerifylist");
          }
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.close();
      }
    });
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      // Prevent zoom in (Ctrl + Plus)
      if (event.ctrlKey && (event.key === '+' || event.key === '=')) {
        event.preventDefault();
      }
      // Prevent zoom out (Ctrl + Minus)
      if (event.ctrlKey && event.key === '-') {
        event.preventDefault();
      }
    };

    // Attach event listener
    window.addEventListener('keydown', handleKeyDown);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);


    // Monitor PDF URL to manage loading state
    useEffect(() => {
      if (pdfUrl !="") {
        setLoading(false);
        setError(false); // Reset error on successful load
      } else {
        setLoading(true);
      }
    }, [pdfUrl]);
  
    const handlePdfLoadError = () => {
      setError(true);
      setLoading(false);
    };
  

    const HandleRMpay = () => {

    if(SubRoleList == 1 || SubRoleList == 3 ){
  
  
  
      Swal.fire({
        title: "Do you want to verify?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#234492",
        cancelButtonColor: "#6c757d",
        confirmButtonText: "Yes, verify it!",
        // html: `
        //   <div>
        //     <input type="checkbox" id="sendOfferLetter" />
        //     <label for="sendOfferLetter">Send offer letter via WhatsApp</label>
        //   </div>
        // `,
      }).then((result) => {
        if (result.isConfirmed) {
          // const sendOfferLetter = document.getElementById("sendOfferLetter").checked;
      
          console.log(state.EmployeeProfile.EmployeeProfileList, "userId");
          if (
            state.EmployeeProfile.EmployeeProfileList != undefined ||
            (state.EmployeeProfile.EmployeeProfileList != null &&
              state.EmployeeProfile.EmployeeProfileList.length > 0 &&
              state.EmployeeProfile.EmployeeProfileList.user_id != undefined &&
              state.EmployeeProfile.EmployeeProfileList.user_id.id != undefined)
          ) {
            console.log(SubRoleList, "SubRoleList");
            const payload = {
              UserId: state.EmployeeProfile.EmployeeProfileList.user_id.id,
              is_pending: SubRoleList == 0 ? true : false,
              is_decline: false, // is_decline: have to be true when the RM needs to approve
              create_employee: true,
              Decline: 0,
              payroll_approved:
                SubRoleList == 0 || SubRoleList == 3 ? true : true,
                // send_whatsapp:  sendOfferLetter, // Add the sendOfferLetter state to the payload
  send_whatsapp:false,
                // whatsapp_verify:  sendOfferLetter, // Add the sendOfferLetter state to the payload
                SubRoleList:SubRoleList,
                Ids:state.EmployeeProfile.EmployeeProfileList.user_id.id ,
                date:state.NeededdatasListed.dateOfJoing,
                        };
             console.log(payload  , "27381972payload");
  
             if(!RMADMIN){ 
            dispatch(SetApprovalCallsActions(payload));
  
             }
              else if(RMADMIN){
                const payload = {
                  UserId: state.EmployeeProfile.EmployeeProfileList.user_id.id,
                  is_pending: SubRoleList == 0 ? true : false,
                  is_decline: false, // is_decline: have to be true when the RM needs to approve
                  create_employee: true,
                  Decline: 0,
                  payroll_approved:
                    SubRoleList == 0 || SubRoleList == 3 ? true : true,
                    // send_whatsapp:  sendOfferLetter, // Add the sendOfferLetter state to the payload
                    send_whatsapp:false,
                    SubRoleList:SubRoleList,
                    Ids:state.EmployeeProfile.EmployeeProfileList.user_id.id ,
                    date:state.NeededdatasListed.dateOfJoing,
                            };
                           dispatch(SetTheJoiningDateCall(payload))
                          //  navigate("/employeeprofile");
  
  
              }

          }
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.close();
        }
        
      });
      
  
  
    }
  
  
  
  
    };
  
  



  return (
    <>
      <div className="PdfViwer">
        {error ? (
          <div style={{ color: "red" }}>Error while reading the pages!</div>
        ) : (
          <>
            <div className="PdfViwers">
              <div className="PDFPAPER_body">
                <div className="row CLOSEPOPUP">
                  <div className="col_inner">
                    <div className="CloseIcon" onClick={(e) => setshow(false)}>
                      {!state.ClientBranchIDs.StatusBtn &&
                      createEmployee &&
                      state.NumberCounts.Editable == 1 ? (
                        <>
                          {/* {whatsApp ? ( */}

                          {Approvel ? (
                            ///----Approved--Employee-----------------

                            <span style={{ color: "#234492" }}>
                              Approved Employee
                            </span>
                          ) : (
                            <>
                              {!Approvel &&
                              //!whatsApp ||
                              SubRoleList != 0 &&
                              createEmployee &&
                              state.NumberCounts.Editable == 1 ? (
                                <>
                                  <button
                                    className="Decline ButtonCSS"
                                    //onClick={(e) => navigate("/employeeVerifylist")}
                                    onClick={(e) => {
                                      HandleDecline(e); 
                                    }}
                                     style={{background:"#ff0000" , marginRight:"15px"}}
                                  >
                                    Reject
                                  </button>
                                  <button
                                    className="verify ButtonCSS"
                                    onClick={(e) => {
                                      // HandleVerify(e);
                                      HandleRMpay(e)
                                    }}
                                    style={{background:"#0fa402" , marginRight:"18px"}}

                                  >
                      {!RMADMIN ? 
                      
                      "Approve":
                      "Not approved yet."
                      
                      }
                        
                                  </button>
                                </>
                              ) : null}
                            </>
                          )}
                        </>
                      ) : null}

                      {SubRoleList == 0 &&
                      state.EmployeeProfile.EmployeeProfileList != undefined &&
                      state.EmployeeProfile.EmployeeProfileList != null &&
                      !state.EmployeeProfile.EmployeeProfileList
                        .payroll_approved 
                        && state.EmployeeProfile.EmployeeProfileList.create_employee == true
&&
                      state.NumberCounts.Editable == 1 ? (
                        <>
                          <button
                            className="Decline ButtonCSS"
                            //onClick={(e) => navigate("/employeeVerifylist")}
                            onClick={(e) => {
                              HandleDecline(e);
                            }}
                            style={{background:"#ff0000" , marginRight:"15px"}}
                          >
                            {/* Decline */}
                            Reject
                          </button>
                          <button
                            className="verify ButtonCSS"
                            onClick={(e) => {
                              HandleVerify(e);
                            }}
                            style={{background:"#0fa402" , marginRight:"18px"}}

                          >
                            {/* Verify */}
                            Approve
                          </button>
                        </>
                      ) : null}

                      <CloseOutlinedIcon className="svg" />
                    </div>
                  </div>
                </div>

                {/* <div className="PDFPAPER custom-pdf-container">
                  <Worker
                    workerUrl={`https://unpkg.com/pdfjs-dist@2.16.105/build/pdf.worker.min.js`}
                    >
                    <Viewer
                      fileUrl={state.pdfdownloadcall.PdfDownloadDatas}
                      // plugins={[defaultLayoutPluginInstance]}

                      plugins={[defaultLayoutPluginInstance, zoomPluginInstance]}                     />
                  </Worker>
                </div> */}
                <div className="PDFPAPER custom-pdf-container">
      {loading ? (
        <div className="loader">
          <img src={LoaderGIf}/>
        </div>
      ) : error ? (
        <div className="error">Failed to load PDF</div>
      ) : (
        <Worker workerUrl={`https://unpkg.com/pdfjs-dist@2.16.105/build/pdf.worker.min.js`}>
          <Viewer
            // fileUrl={pdfUrl}
            fileUrl={state.pdfdownloadcall.PdfDownloadDatas}
            onError={handlePdfLoadError}
            plugins={[defaultLayoutPluginInstance, zoomPluginInstance]}
          />
        </Worker>
      )}
    </div>

              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default PdfView;